import React from "react";
import TableText from "@/components/table/TableText";
import { numConvert, calculation, sum } from "@/method";
import _ from 'lodash'
import moment from 'moment'

const totalIndex = [11];
export const weeks = {
    0: "日",
    1: "一",
    2: "二",
    3: "三",
    4: "四",
    5: "五",
    6: "六",
};
const keys = new Array(31).fill(1).map((x, i) => `m${i + 1}`);
export default (data) => {
    // Total
    data.forEach((item, i) => {
        data[i].total = keys.reduce((a, b) => a += numConvert(item[b]), 0).toFixed(2);
    });

    [...keys, 'total'].forEach(name => {
        data[11][name] = data.reduce((a, b, i) => i < 11 ? a + numConvert(b[name]) : a, 0).toFixed(2);
    });
    return data
}

export const columns = (onChange, date, print) => {
    // 获取当月天数
    const days = moment(date).daysInMonth();
    return [
        {
            title: `Pickup 日期`,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: !print && "left",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };
                return <TableText data={props} />
            }
        },
        ...new Array(days).fill(1).reduce((a, b, i) => {
            return [
                ...a,
                {
                    title: weeks[moment(`${date}-${i + 1}`).day()],
                    align: "center",
                    children: [{
                        title: moment(`${date}-${i + 1}`).format('MM-D'),
                        dataIndex: `m${i + 1}`,
                        key: `m${i + 1}`,
                        align: "center",
                        width: 120,
                        render: (text, record, index) => {
                            const props = {
                                text,
                                index,
                                type: totalIndex.includes(index) ? 'number' : 'inputNumber',
                                name: `m${i + 1}`,
                                onChange,
                                totalIndex,
                            };
                            return (
                                <TableText data={props} />
                            )
                        }
                    }]
                }
            ]
        }, []),
        {
            title: `Total`,
            dataIndex: 'total',
            key: 'total',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "total",
                    onChange,
                    totalIndex,
                };
                return (
                    <TableText data={props} />
                )
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.6/compute.js